import { useEffect, useState } from "react";
import InputFormExtension from "@/Layouts/components/InputComponents/InputFormExtension";
import { NumberOrString } from "@/Layouts/components/InputComponents/InputValue/types";
import { TInputData } from "@/Layouts/types/InputComponents/InputFormExtension";
import { Box, Button, Dialog, DialogContent, DialogTitle, Typography } from "@mui/material";
import clsx from "clsx";

type TransferAmountDialogProps = {
	isOpen: boolean;
	defaultValue: number;
	onCloseDialog: () => void;
	onConfirm: (value: number) => void;
};

const TransferAmountDialog = (props: TransferAmountDialogProps) => {
	const { isOpen, onCloseDialog, onConfirm, defaultValue } = props;

	const [internalValue, setInternalValue] = useState(defaultValue);

	const handleActionUpdate = (value: NumberOrString) => {
		setInternalValue(Number(value));
	};

	const handleConfirm = () => {
		onConfirm(internalValue);
		onCloseDialog();
	};

	const handleOnClose = () => {
		setInternalValue(defaultValue);
		onCloseDialog();
	};

	useEffect(() => {
		setInternalValue(defaultValue);
		return () => {};
	}, [defaultValue]);

	return (
		<Dialog
			classes={{
				paper: "!rounded-[10px] !shadow-md",
			}}
			open={isOpen}
			onClose={handleOnClose}
			PaperProps={{
				style: {
					minWidth: "232px",
					maxWidth: "232px",
				},
			}}
			disableEscapeKeyDown
			onDoubleClick={(e) => {
				e.stopPropagation();
			}}
		>
			<DialogTitle>
				<Typography className={"!font-montserrat !text-sm !font-[600] !text-default uppercase"}>Transfer Amount</Typography>
			</DialogTitle>
			<DialogContent>
				<Typography className={"!font-sans !text-sm !font-medium !text-default !pb-[24px]"}>
					Please enter the proposed Transfer Amount for this vehicle.
				</Typography>
				<InputFormExtension
					data={
						[
							{
								type: "Dollar",
								decimalsEditable: true,
								delta: 0.01,
								min: Number.MIN_VALUE,
								max: Number.MAX_VALUE,
								decimals: 2,
							},
						] as TInputData[]
					}
					onActionUpdate={handleActionUpdate}
					sx={{ width: "95px" }}
					value={internalValue}
				/>
				<Box className="!mt-[24px]">
					<Button
						variant="contained"
						aria-controls="select-plan-dialog-assign-btn-menu"
						className="h-[30px] !rounded-[6px] !bg-gray-blue !shadow-none w-[82px] !mr-[20px]"
						onClick={handleOnClose}
					>
						<Typography className="select-plan-dialog-assign-btn-text">Cancel</Typography>
					</Button>
					<Button
						variant="contained"
						aria-controls="select-plan-dialog-assign-btn-menu"
						className={clsx({
							"h-[30px] !rounded-[6px] !shadow-none !font-sans !capitalize !text-white !text-[14px]": true,
							"!bg-primary": !!internalValue,
							"!bg-disabled": !internalValue,
						})}
						onClick={handleConfirm}
						disabled={!internalValue}
					>
						<Typography className="select-plan-dialog-assign-btn-text">Confirm</Typography>
					</Button>
				</Box>
			</DialogContent>
		</Dialog>
	);
};

export default TransferAmountDialog;
